import { Injectable } from '@angular/core';

/**
 * JwtService - Servicio especializado para manejo de tokens JWT
 * Responsabilidad única: Parsear y validar tokens JWT
 */
@Injectable({
  providedIn: 'root',
})
export class JwtService {
  constructor() { }

  /**
   * Parsea un token JWT y devuelve el payload decodificado
   * @param token Token JWT a parsear
   * @returns Payload decodificado del token
   */
  parseJwt(token: string): JwtPayload {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );

    return JSON.parse(jsonPayload);
  }

  /**
   * Verifica si un token JWT ha expirado
   * @param expirationTime Tiempo de expiración (timestamp en segundos)
   * @returns true si el token ha expirado, false en caso contrario
   */
  isTokenExpired(expirationTime: number): boolean {
    const expirationDate = new Date(expirationTime * 1000);
    const currentDate = new Date();
    return expirationDate < currentDate;
  }
}

/**
 * Interface para el payload de un JWT
 */
export interface JwtPayload {
  name: string;
  role: string;
  account_type: string;
  account_name: string;
  account_reference: string;
  user_reference: string;
  assigned_smtp: string | null;
  smtp_from: string | null;
  exp: number;
  [key: string]: any;
}
